import { Component } from '@hatiolab/things-scene'

import ControlBase, { DIRECTION, INOUT, NODE, PIPELINE } from './base/control-base'

const IMAGE = new URL('../icons/message-sequence.png', import.meta.url).href

const NATURE = {
  mutable: false,
  resizable: false,
  rotatable: false,
  properties: [],
  help: '/eipatterns/message-sequence/message-sequence'
}

export default class MessageSequence extends ControlBase {
  static IMAGE: HTMLImageElement

  static get nature() {
    return NATURE
  }

  get nodes(): NODE[] {
    return [
      {
        name: 'In',
        description: 'Message inlet',
        inout: INOUT.IN,
        type: PIPELINE.MESSAGE,
        direction: DIRECTION.WEST
      },
      {
        name: 'Out',
        description: 'Message outlet',
        inout: INOUT.OUT,
        type: PIPELINE.MESSAGE,
        direction: DIRECTION.EAST
      }
    ]
  }

  getImageElement(): HTMLImageElement {
    if (!MessageSequence.IMAGE) {
      MessageSequence.IMAGE = new Image()
      MessageSequence.IMAGE.src = IMAGE
    }

    return MessageSequence.IMAGE
  }
}

Component.register('message-sequence', MessageSequence)
